import React from "react";
import { useNavigate } from "react-router-dom";
import { showToast, useCustomToast } from "./toastUtils";

export const handleErrors = (
  error: any,
  setErrorMessage: (message: string) => void
) => {
  if (
    error.response &&
    (error.response.status === 400 || error.response.status === 500)
  ) {
    setErrorMessage("An error occurred.");
    showToast("An error occurred.", "error", 5000);
      
    const errorEl = document.getElementById("error-message");
    errorEl?.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "nearest",
    });

    document
      .getElementById("top-of-page")
      ?.scrollIntoView({ behavior: "smooth" });
  }

  if (error.response && error.response.status === 500) {
    const navigate = useNavigate();
    navigate("/error");
  }
};

export const clearFieldError = (
  name: string,
  fieldErrors: any,
  setFieldErrors: React.Dispatch<React.SetStateAction<any>>,
) => {
  if (fieldErrors && fieldErrors.hasOwnProperty(name)) {
    const updatedErrors = { ...fieldErrors };
    delete updatedErrors[name];
    setFieldErrors(updatedErrors);
  }
};

export const handleError = (e: any) => {
  const errorMessage = e.response?.data || e.message;
  
  showToast(errorMessage, "error", 3000);
  
  throw new Error(errorMessage);
};

export const useErrorHandler = () => {
  const navigate = useNavigate();
  const { showToast } = useCustomToast();
  
  const handleComponentError = (e: any) => {
    const errorMessage = e.response?.data || e.message;
    showToast(errorMessage, "error", 5000);
    throw new Error(errorMessage);
  };
  
  const handleComponentErrors = (
    error: any,
    setErrorMessage: (message: string) => void
  ) => {
    if (
      error.response &&
      (error.response.status === 400 || error.response.status === 500)
    ) {
      setErrorMessage("An error occurred.");
      
      showToast("An error occurred.", "error");
        
      const errorEl = document.getElementById("error-message");
      errorEl?.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
  
      document
        .getElementById("top-of-page")
        ?.scrollIntoView({ behavior: "smooth" });
    }
  
    if (error.response && error.response.status === 500) {
      navigate("/error");
    }
  };
  
  return { 
    handleError: handleComponentError, 
    handleErrors: handleComponentErrors,
    clearFieldError 
  };
};